<template></template>
<script setup lang="ts">
import config, { getClientLogLevel } from '@/config';
import { useHead } from '@unhead/vue';
import type { Head, MaybeComputedRef } from '@unhead/vue';
import isSSR from '@/utils/isSSR';

const preloadFontLink = (fontName: string, type: string): MaybeComputedRef<Record<string, string>> => ({
  rel: 'preload',
  type: 'font/' + type,
  href: `/fonts/${fontName}.${type}`,
  as: 'font',
  crossorigin: 'anonymous',
});

const scripts: Head['script'] = [
  {
    key: 'logLevel',
    type: 'text/javascript',
    children: `
        window.LOG_LEVEL = "${getClientLogLevel()}";
      `,
  },
];

if (isSSR) {
  scripts.push({
    key: 'analyticsUrl',
    src: config.analytics.scriptSrc[config.env],
    async: true,
  });
}

useHead({
  link: [
    // Preload only absolutely necessary stuff to avoid slowness in the page load
    preloadFontLink('chevin-light', 'woff2'),
    preloadFontLink('chevin-demibold', 'woff2'),
  ],
  script: scripts,
});
</script>
